
import Suggested from '@/graphql/queries/product/SuggestedProducts'

export default {
  async fetch() {
    const { data } = await this.$graphql.query({
      clientId: 'eshop',
      query: Suggested,
      collection: true,
      variables: {
        order: 'createdAt_DESC',
        first: 16
      }
    })

    this.items = data
  },
  data() {
    return {
      items: []
    }
  }
}
